/* ---------------------------------------------------------------------------
   Bottega d'Arte Stringa — la quantita', ovunque si veda un prodotto nel carrello.
   Chiesto il 15/09/2026: si deve poter vedere quanti pezzi ci sono e cambiarli,
   per tutti i prodotti.

   Due posti, un file solo:
   - il pannello del carrello che si apre dal bottone "Aggiungi" (sta in cinque
     pagine, con lo stesso markup);
   - la pagina Carrello, dove la quantita' era scritta a mano e non si toccava.

   Sul pannello si avvolge openCart invece di riscriverla in ogni pagina: la
   funzione originale continua a fare il suo lavoro, qui si aggiunge solo il
   selettore e si tiene aggiornato quello che dipende dalla quantita'.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  var SOGLIA_SPEDIZIONE = 250;

  // "€186,00" -> 186 ; "€1.234,50" -> 1234.5
  function aNumero(testo) {
    var t = String(testo || "").replace(/[^\d.,]/g, "");
    if (!t) return null;
    if (t.indexOf(",") > -1) t = t.replace(/\./g, "").replace(",", ".");
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }

  function inEuro(n) {
    return "€" + n.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d)\,)/g, ".");
  }

  var css = document.createElement("style");
  css.textContent = [
    ".avq{display:inline-flex;align-items:center;border:1px solid var(--line,#E3DDCE);border-radius:999px;",
    "overflow:hidden;background:var(--surface,#fff);vertical-align:middle}",
    ".avq button{width:30px;height:30px;border:0;background:transparent;color:var(--ink,#12363F);",
    "font-size:15px;line-height:1;cursor:pointer;font-family:'DM Sans',Arial,sans-serif}",
    ".avq button:hover{background:var(--surface-alt,#F1ECE1)}",
    ".avq button:disabled{opacity:.35;cursor:default}",
    ".avq input{width:38px;height:30px;border:0;border-left:1px solid var(--line,#E3DDCE);",
    "border-right:1px solid var(--line,#E3DDCE);text-align:center;background:transparent;",
    "font-family:'DM Sans',Arial,sans-serif;font-size:13px;font-weight:600;color:var(--ink,#12363F);",
    "-moz-appearance:textfield}",
    ".avq input::-webkit-outer-spin-button,.avq input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}",
    ".avq input:focus{outline:2px solid var(--brass,#A9824A);outline-offset:-2px}",
    ".avq-riga{display:flex;align-items:center;gap:9px;margin-top:8px;",
    "font-family:'DM Sans',Arial,sans-serif;font-size:11.5px;color:var(--ink-soft,#54666B)}"
  ].join("");
  document.head.appendChild(css);

  // Costruisce un selettore. `alCambio` riceve la quantita' nuova.
  function selettore(iniziale, alCambio) {
    var box = document.createElement("div");
    box.className = "avq";
    var meno = document.createElement("button");
    meno.type = "button"; meno.textContent = "−";
    meno.setAttribute("aria-label", "Togli un pezzo");
    var campo = document.createElement("input");
    campo.type = "number"; campo.min = "1"; campo.max = "99"; campo.step = "1";
    campo.value = iniziale;
    campo.setAttribute("inputmode", "numeric");
    campo.setAttribute("aria-label", "Quantità");
    var piu = document.createElement("button");
    piu.type = "button"; piu.textContent = "+";
    piu.setAttribute("aria-label", "Aggiungi un pezzo");
    box.appendChild(meno); box.appendChild(campo); box.appendChild(piu);

    function valore() { return Math.min(99, Math.max(1, parseInt(campo.value, 10) || 1)); }
    function applica(n) {
      campo.value = n;
      meno.disabled = n <= 1;
      piu.disabled = n >= 99;
      alCambio(n);
    }
    meno.addEventListener("click", function () { applica(Math.max(1, valore() - 1)); });
    piu.addEventListener("click", function () { applica(Math.min(99, valore() + 1)); });
    campo.addEventListener("input", function () { if (campo.value !== "") applica(valore()); });
    campo.addEventListener("blur", function () { applica(valore()); });
    applica(valore());
    return { radice: box, imposta: applica, leggi: valore };
  }

  // --- 1. il pannello del carrello -----------------------------------------
  var prezzoDrawer = document.getElementById("cartDrawerPrice");
  if (prezzoDrawer && typeof window.openCart === "function") {
    var originale = window.openCart;
    var unitario = null, comando = null;

    var riga = document.createElement("div");
    riga.className = "avq-riga";
    var etichetta = document.createElement("span");
    etichetta.textContent = "Quantità";
    riga.appendChild(etichetta);

    function scriviTotale(n) {
      if (unitario == null) return;
      prezzoDrawer.textContent = inEuro(unitario * n) + (n > 1 ? "  (" + n + " × " + inEuro(unitario) + ")" : "");
      var badge = document.querySelector(".cart-dot span");
      if (badge) badge.textContent = n;
    }

    window.openCart = function (brand, name, desc, oldPrice, newPrice, img, qta) {
      originale.apply(this, arguments);
      var n = Math.min(99, Math.max(1, parseInt(qta, 10) || 1));
      unitario = aNumero(newPrice);
      if (unitario == null) return;             // senza un prezzo leggibile non si conta niente
      if (!comando) {
        comando = selettore(n, scriviTotale);
        riga.appendChild(comando.radice);
        prezzoDrawer.parentNode.insertBefore(riga, prezzoDrawer.nextSibling);
      }
      comando.imposta(n);
    };
  }

  // --- 2. la pagina Carrello -----------------------------------------------
  var righe = [].slice.call(document.querySelectorAll(".cart-item"));
  if (righe.length) {
    var articoli = [];

    righe.forEach(function (item) {
      var meta = item.querySelector(".ci-meta");
      var prezzo = item.querySelector(".ci-price");
      if (!meta || !prezzo) return;

      var quanti = parseInt((meta.textContent.match(/(\d+)/) || [])[1], 10) || 1;
      var totaleRiga = aNumero(prezzo.textContent);
      if (totaleRiga == null) return;

      var dato = { unitario: totaleRiga / quanti, quantita: quanti, prezzo: prezzo };
      articoli.push(dato);

      var esempio = meta.querySelector(".example-tag");
      meta.textContent = "";
      var cmd = selettore(quanti, function (n) {
        dato.quantita = n;
        prezzo.textContent = inEuro(dato.unitario * n);
        ricalcola();
      });
      meta.appendChild(cmd.radice);
      if (esempio) { meta.appendChild(document.createTextNode(" ")); meta.appendChild(esempio); }
      meta.style.display = "flex";
      meta.style.alignItems = "center";
      meta.style.gap = "8px";
      meta.style.marginTop = "6px";
    });

    var testa = document.querySelector(".cart-head span:last-child");
    var subtotale = document.querySelector(".cart-total b");
    var barraLbl = document.querySelector(".ship-progress .lbl");
    var barra = document.querySelector(".ship-progress .bar i");

    function ricalcola() {
      var pezzi = 0, somma = 0;
      articoli.forEach(function (a) { pezzi += a.quantita; somma += a.unitario * a.quantita; });

      if (testa) testa.textContent = pezzi === 1 ? "1 articolo" : pezzi + " articoli";
      if (subtotale) subtotale.textContent = inEuro(somma);

      // la barra della spedizione gratuita deve dire il vero, non restare ferma
      // sul numero scritto a mano quando il carrello cambia
      if (barraLbl) {
        var manca = SOGLIA_SPEDIZIONE - somma;
        barraLbl.innerHTML = manca > 0
          ? "Ti mancano <b>" + inEuro(manca) + "</b> alla spedizione gratuita"
          : "<b>Spedizione gratuita raggiunta</b>";
      }
      if (barra) barra.style.width = Math.min(100, (somma / SOGLIA_SPEDIZIONE) * 100) + "%";
    }

    ricalcola();
  }
})();
